import { BaseService, RequestType, ResponseType } from "@intech/react-service";

class Adesao extends BaseService {
  constructor() {
    super("adesao");
  }

  Download = () =>
    this.CreateRequest<any>(RequestType.GET, `download`, null, ResponseType.Blob);

  Upload = (model: FileUploadEntidade) =>
    this.CreateRequest(RequestType.POST, `upload`, model);
}

export const AdesaoService = new Adesao();

export class FileUploadEntidade {
  public File: any;
  public source: string;
  public Size: number;
  public Width: number;
  public Height: number;
  public Extension: string;
}
